import { Component, inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { PersonService } from '../../../services/person.service';
import { MessageService } from '../../../services/message.service';
import { Person } from '../../../classes/person.class';
import { ICustomerCreate, ICustomerUpdate, IPerson } from '../../../typing/person.interface';
import { LoaderComponent } from '../../loader/loader.component';
import { CloseButtonComponent } from '../../close-button/close-button.component';

@Component({
    selector: 'app-order-contact-form',
    standalone: true,
    imports: [
        FormsModule,
        MatButton,
        MatDialogContent,
        MatFormField,
        MatInput,
        MatLabel,
        ReactiveFormsModule,
        LoaderComponent,
        MatDialogTitle,
        CloseButtonComponent,
    ],
    templateUrl: './order-contact-form.component.html',
    styleUrl: './order-contact-form.component.scss'
})
export class OrderContactFormComponent implements OnInit {
    readonly dialogRef = inject(MatDialogRef<OrderContactFormComponent>);
    readonly fb = inject(FormBuilder);
    readonly personService = inject(PersonService);
    public data: { personId?: number } = inject(MAT_DIALOG_DATA);
    protected messagesService = inject(MessageService);
    loading = signal<boolean>(false);

    customer = new Person({} as IPerson);

    personForm= this.fb.group({
        firstName: [''],
        lastName: [''],
        phone: ['', Validators.required]
    });

    ngOnInit(): void {
        if (this.data.personId) {
            this.loading.set(true);
            this.personService.getPerson(this.data.personId).subscribe( {
                next: data => {
                    this.customer.data = data;
                    this.personForm.setValue(this.customer.formCustomerData());
                },
                error: error => {this.messagesService.errorMessage(error.message);}
            }).add(() => this.loading.set(false));

        }
    }

    onSubmit(): void {
        if (!this.personForm.valid) {
            return;
        }

        const request = this.data.personId ?
            this.personService.updateCustomer(this.customer.dataForCustomerUpdate(this.personForm.value as ICustomerUpdate))
            : this.personService.create(this.customer.dataForCustomerCreate(this.personForm.value as ICustomerCreate));

        request.subscribe({
            next: result => {
                this.messagesService.successMessage('Контакт успешно сохранен');
                this.dialogRef.close(result);},
            error: error => {this.messagesService.errorMessage(error.message);}
        });
    }
}
